export default __webpack_public_path__ + "static/media/allgemein_46.efb755ca.jpg";